import { Component } from '@angular/core';
import { ForumAnswerComponent } from '../forum-answer/forum-answer.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/services/app-service.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-forum-details',
  templateUrl: './forum-details.component.html',
  styleUrls: ['./forum-details.component.scss']
})
export class ForumDetailsComponent {
  forum: any = {};
  forumId: any = '';
  answers: any = [];
  editor: any = ClassicEditor;
  forumAnswer = '';
  constructor(private appService: AppService, private dialog: MatDialog, private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe((res: any) => {
      this.forumId = res.id;
      this.getForumsDetails();
    })

  }

  getForumsDetails() {
    this.appService.getForumDetails(this.forumId).subscribe((res: any) => {
      this.forum = res;
    })
    this.appService.getAnswersDetails(this.forumId).subscribe((res: any) => {
      this.answers = res;
    })
  }

  ngOnInit(): void {
    setTimeout(() => {
      document.querySelectorAll('.ck.ck-toolbar .ck-dropdown')[2]['style']['display'] = 'none';
    }, 200);
  }

  save() {
    let body = {
      "answer": this.forumAnswer,
      "name": sessionStorage.getItem('userName'),
      "email": sessionStorage.getItem('email')||'null',
      "type": "FORUM",
      "item_id": this.forumId,
      "status": "Active",
      "createdBy": sessionStorage.getItem('loginId'),
      "createdAt": new Date().toISOString().substring(0,10),
      "updatedBy": sessionStorage.getItem('loginId'),
      "updatedAt": new Date().toISOString().substring(0,10)
    }
    this.appService.saveAnswersDetails(body).subscribe((res:any)=>{
      this.appService.getAnswersDetails(this.forumId).subscribe((res: any) => {
        this.answers = res;
        this.forumAnswer = '';
      })
    })
  }

  back() { 
    this.router.navigateByUrl('/forums');
  }
}
